import Client from 'config/axios';

/**
 * Marca el modal de lanzamiento AdvPro (webinar 5-ago-2026) como descartado
 * definitivamente para la company del admin autenticado (la company se deriva
 * del token en el backend).
 */
export const dismissAdvproLaunch = async (token: string) => {
  return await Client.post(
    'company/advpro-launch/dismiss',
    {},
    {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }
  )
    .then(response => response.data.data)
    .catch(error => ({
      errors: error?.response?.data?.data
    }));
};
